<template>
  <div>
    <div v-if="getAchievementFeed.length > 0">
      <div class="text-start">
        <div class="game-title gt-3 mb-0 pb-0">Latest Activity</div>
      </div>
      <div class="border-game"></div>
      <div class="mb-3"></div>
      <div v-for="item in paginatedFeed" :key="item" class="mb-3">
        <div v-if="item.achievement">
          <UserCard v-bind="item">
            <AchievementBadge v-bind="item.achievement"
          /></UserCard>
        </div>
        <div v-else>
          <GroupFeedCard v-bind="item" />
        </div>
      </div>
      <div class="mt-4" v-if="totalPages > 1">
        <button
          class="btn btn-dark fs-5 me-3"
          aria-label="Previous"
          :disabled="currentPage === 1"
          @click="previousPage()"
        >
          <i class="bi bi-arrow-left"></i>
        </button>
        <span class="fw-bold">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          class="btn btn-dark fs-5 ms-3"
          aria-label="Next"
          :disabled="currentPage === totalPages"
          @click="nextPage()"
        >
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AchievementBadge from "@/components/activity/AchievementBadge.vue";
import UserCard from "@/components/activity/UserCard.vue";
import GroupFeedCard from "@/components/activity/GroupFeedCard.vue";

export default {
  name: "AchievementFeed",
  components: { AchievementBadge, UserCard, GroupFeedCard },
  data() {
    return {
      currentPage: 1, // Current page number
      pageSize: 10 // Number of items per page
    };
  },
  props: {},
  computed: {
    ...mapGetters("achievements", ["getAchievementFeed"]),
    // Calculate total pages based on feed length and page size
    totalPages() {
      return Math.ceil(this.getAchievementFeed.length / this.pageSize);
    },
    // Get the feed items for the current page
    paginatedFeed() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.getAchievementFeed.slice(start, end);
    }
  },
  methods: {
    // Navigate to the next page
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    // Navigate to the previous page
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
};
</script>
